import script from "./AdministratorProjectInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorProjectInfo.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorProjectInfo.vue?vue&type=style&index=0&id=7129662e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7129662e"]])

export default __exports__